import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AutoCompleteModule } from "primeng/autocomplete";
import { ErrormessageModule } from '../../validation/errormessage/errormessage.module';

import { PCPCommunityAutoCompleteComponent } from "./pcp-community-autocomplete.component";

@NgModule({
    imports: [
        CommonModule,
        ErrormessageModule,
        FormsModule,
        AutoCompleteModule,
        PCPCommunityAutoCompleteComponent
    ],
    exports: [PCPCommunityAutoCompleteComponent]
})
export class PCPCommunityAutoCompleteModule { }
